export const getLocalStorageItem = <T>(item: string): T | string => {
  // ЭТАП 1 · Шаг 3 — SSR-safe: на сервере localStorage нет.
  if (typeof localStorage === 'undefined') return '';
  if (item && typeof item === 'string' && localStorage.getItem(item)) {
    return JSON.parse(localStorage.getItem(item) || '{}') as T;
  }
  return '';
};
